<template>
  <div id="app">
    <!-- 头部内容 + 第一屏 melo -->
    <YuliHeader
      :is-scroll="isScroll"
      :active-btn="activeName"
      :menu-list="menuList"
      @backTop="handleBackTop"
    ></YuliHeader>
    <!-- 悬浮窗 -->
    <main id="container">
      <MainContent
        id="services"
        v-webpb
        :main-opacity="mainOpacity"
      ></MainContent>
      <YuliConnect id="faq"></YuliConnect>
      <!-- 页脚 -->
    </main>
  </div>
</template>

<script>
import YuliHeader from "@/components/Pc/components/YuliHeader";
import MainContent from "@/components/Pc/components/Main/MainContent";
import YuliConnect from "@/components/Pc/components/YuliConnect";

export default {
  name: "IndexPage",
  components: {
    YuliHeader,
    MainContent,
    YuliConnect,
  },
  data() {
    return {
      isScroll: false,
      menuList: [
        { name: "Game", link: "rolePlay" },
        { name: "Feature", link: "feature" },
        { name: "Character", link: "nft" },
        { name: "Roadmap", link: "roadMap" },
        { name: "Token", link: "token" },
        { name: "Partners", link: "partners" },
      ],
      scrollList: [],
      mainOpacity: 0,
      activeName: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      const list = this.menuList;
      list.forEach((item) => {
        item.Top = document.getElementById(item.link).offsetTop;
      });
      this.scrollList = list;
    });
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > window.screen.height - 200) {
        !this.isScroll && (this.isScroll = true);
      } else {
        this.isScroll && (this.isScroll = false);
      }
      if (this.mainOpacity <= 0.9) {
        this.mainOpacity = (scrollTop * 1) / window.screen.height;
      } else {
        this.mainOpacity = 0.9;
      }

      if (scrollTop < window.screen.height - 600) {
        this.activeName = "";
        return;
      }
      this.scrollList.forEach((item) => {
        if (scrollTop - item.Top > -300) {
          this.activeName = item.link;
        }
      });
    },
    handleMenuLink(link) {
      let anchorH = document.getElementById(link).offsetTop;
      if (link === "feature") {
        anchorH += 120;
      }
      if (link === "rolePlay") {
        anchorH += 260;
      }
      if (link === "roadMap") {
        anchorH += 250;
      }
      window.scrollTo({ top: anchorH, behavior: "smooth" });
    },
    handleBackTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.mainOpacity = 0;
    },
  },
};
</script>
<style lang="less" scoped>
@import url("~@/common/less/webpbg.less");
#app {
  width: 100%;
  min-width: 1200px;
}
#container {
  width: 100%;
  position: relative;
  #services {
    position: fixed;
    top: 0;
    min-height: 900px;
    width: 100%;
    .webpbg("~@/assets/images/YuliApp/main/bg_01.png");
  }
  #token,
  #argArt,
  #rolePlay,
  #feature,
  #deep,
  #fete,
  #nft,
  #team,
  #partners,
  #faq,
  #power,
  #roadMap {
    position: relative;
    top: 100vh;
    overflow: hidden;
    position: relative;
  }
}
</style>
